import { useEffect, useState } from "react";

import Card from 'react-bootstrap/Card';

import "./HomeReglementation.css";
import MapEsri from "./EsriMap";
import {useMapContext} from "../../contexts/MapContext"
import {useAdminContext} from "../../contexts/AdminContext"

import MapFilter from "./MapFilter";
import type { ObservationType } from "../types/types";


function isRangeOverSevenDays(dateDeb: Date, dateFin: Date) {
  const diffMs = dateFin.getTime() - dateDeb.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  return diffDays > 7;
}


export default function HomeMap() {
  const {setErrorDateMessage, dateDeb, dateFin, selectedBoatCodes, setUniqueBoats} = useMapContext();
  const {tabIdBoats, allObservations, initialLoadDone} = useAdminContext();
  const [filteredObs, setFilteredObs] = useState<ObservationType[]>([]);
  


  const filterObs = (observations: ObservationType[]) => {

    if (dateDeb > dateFin){
      setErrorDateMessage("Temporalité invalide, veuillez en choisir une autre");
      return []
    }

    if (isRangeOverSevenDays(dateDeb, dateFin)) {
      setErrorDateMessage("La temporalité dépasse 7 jours, veuillez en choisir une autre");
      return []
    }

    setErrorDateMessage("");
    //Filtre temporel
    let filteredObs = observations.filter(obs => {
          const obsDate = new Date(obs.date_creation +"Z");
          return obsDate >= dateDeb && obsDate <= dateFin;
    });

    //Bateaux présent dans la fenetre temporelle
    const boats = filteredObs.map(obs => {return obs.bateau_id;});
    const uniqueBoats = boats.reduce((acc:any, code:any) => {
      if (!acc.includes(code)) {
        acc.push(code);
      }
      return acc;
    }, []);
    setUniqueBoats(uniqueBoats);

    //Filtre par bateau
    if (selectedBoatCodes.length !==0){
      console.log(selectedBoatCodes)
      filteredObs = filteredObs.filter(obs => {
          return selectedBoatCodes.includes(tabIdBoats[obs.bateau_id].code);
      });
    }
    console.log("Observations filtrées", filteredObs)
    return filteredObs;
  };

  // A chaque nouvelle subscription ou quand le filtre change
  useEffect(() => {
    if (!allObservations.length) return;
    console.log("useeffect de filtre", !allObservations.length, allObservations)
    const filteredObs = filterObs(allObservations);
    setFilteredObs(filteredObs);
    
  }, [allObservations, dateDeb, dateFin, selectedBoatCodes]);

  return (
      <Card>
        <Card.Body>
          {!initialLoadDone ? (
            <div className="loader-wrapper">
              <div className="loader"></div>
                <p>Chargement des données...</p>
            </div>
          ) :
            <div className="map-container2">
              <MapEsri observationData={filteredObs} />
                <div className="right">
                    <MapFilter></MapFilter>
                </div>
            </div>
          }
        </Card.Body>
      </Card>
      )
}
